<template>
	<div class="maxBig">
		<div class="titles">
			<div class="p1" style="font-size: 0.48rem;font-weight: 800;color: #333333;margin-bottom: 0.1rem;margin-left: 0.25rem;">交道教育</div>
			<img style="display: block;height: 0.16rem;margin-left: 0.25rem;" src="../../../assets/img/trainingRegistration/jdjy.png" />
		</div>
		<div class="conconts">
			客货运运输企业专业培训平台，集视频、音频、实时资讯、为一体，将交通运输行业传统培训考试进行线上整合，随时随地学习、练习和考试；运用人脸识别、活体检测、触屏签字等技术实时监控学习过程，一键报表生成、打印，切实解决了从业人员时间不灵活，掌握知识难，上级部门培训要求落实不到位等问题，是交通人的第二课堂。
		</div>
		<div class="maxBtns" @click="downloadJd" >下载交道</div>
		<div class="maxMain">
			<div class="titles1">
				<div class="p1" style="font-size: 0.48rem;font-weight: 800;color: #333333;margin-bottom: 0.1rem;margin-left: 0.25rem;">意向信息</div>
				<img style="display: block;height: 0.16rem;margin-left: 0.25rem;" src="../../../assets/img/trainingRegistration/yxxx.png" />
			</div>
			<div class="maxForm">
				<p class="p2">企业名称</p>
				<input class="inputs" type="text" v-model="form.name"  placeholder="请输入企业名称" />
			</div>
			
			<div class="maxForm">
				<p class="p2">专业类型</p>
				<input class="inputs" type="text" v-model="form.type"  placeholder="请输入专业类型" />
			</div>
			
			<div class="maxForm">
				<p class="p2">规模</p>
				<input class="inputs" type="text" v-model="form.scale"  placeholder="请输入规模" />
			</div>
			
			<div class="maxForm">
				<p class="p2">联系人</p>
				<input class="inputs" type="text" v-model="form.contact"  placeholder="请输入联系人" />
			</div>
			
			<div class="maxForm">
				<p class="p2">联系人手机号</p>
				<input class="inputs" type="text" v-model="form.phone"  placeholder="请输入联系人手机号" />
			</div>
			<div class="maxBtn" @click="sub"></div>
			
		</div>
		
	</div>
</template>
<script>
	import { Toast, Sidebar, List, SidebarItem, PullRefresh, Overlay, Tab, Tabs, Cell, Loading, Card, Dialog,Notify  } from 'vant';
	import request from '@/utils/request';
	export default {
		components: {
			[Toast.name]: Toast,
			[Sidebar.name]: Sidebar,
			[List.name]: List,
			[SidebarItem.name]: SidebarItem,
			[PullRefresh.name]: PullRefresh,
			[Overlay.name]: Overlay,
			[Tab.name]: Tab,
			[Tabs.name]: Tabs,
			[Cell.name]: Cell,
			[Loading.name]: Loading,
			[Dialog.name]: Dialog,
			[Notify.name]: Notify
		},
		data() {
			return {
				form: {
					name: '',
					scale: '',
					contact:'',
					phone:'',
					type:'',
					sign:'',
				}
			};
		},
		created() {
			document.title = "培训登记";
	
		},
		mounted() {
			let _this = this;
		},
	
		methods: {
			sub(){
				let _this = this;
				console.log(this.form)
				if (_this.form.contact == '') {
					Notify('联系人不能为空');
					return false;
				}
				if (_this.form.phone == '') {
					Notify('手机号不能为空');
					return false;
				}
				let invoicePhone = /^1[0-9]{10}$/;
				if (!invoicePhone.test(this.form.phone)) {
					Notify('手机号格式不正确');
					this.form.phone = '';
					return false;
				}
				let urls = Global.env + Global.apiCore.addIntentUser;
				_this.form.sign = md5(_this.form.phone + "zpkjcms")
				return new Promise((resolve, reject) => {
					request({
						url: urls,
						method: 'post', //查询一般为get
						data: _this.form //get
					})
						.then(response => {
							Notify({ type: 'success', message: '登记成功' });
							_this.form.sign = '';
							this.form = {};
						})
						.catch(error => {
							Dialog.alert({
								message: error.errmsg
							}).then(() => {
								// on close
							});
							return reject(error);
						});
				});
				
			},
			downloadJd(){
				window.location.href = "https://upgrade.jiaodao11.com";
			},
		}
	};
</script>

<style scoped>
	.maxBig{
		overflow: hidden;
		display: block;
		width: 100%;
		padding-bottom: 0.4rem;
		/* height: 26rem; */
		background: url(../../../assets/img/trainingRegistration/bjt.png)no-repeat;
		background-size: 100% 100%;
	}
	.titles{
		overflow: hidden;
		display: block;
		width: 5.64rem;
		/* height: 0.82rem; */
		margin: 0 auto;
		margin-top: 7rem;
		border-left: 0.13rem solid #C72E2E;
	}
	.conconts{
		width: 5.64rem;
		font-size: 0.3rem;
		margin: 0 auto;
		color: #333333;
		margin-top: 0.28rem;
		line-height: 0.52rem;
	}
	.maxMain{
		width: 90%;
		/* height: 11.85rem; */
		background: #fff;
		border-radius: 0.6rem;
		margin: 0 auto;
		margin-top: 1rem;
		overflow: hidden;
	}
	.titles1{
		overflow: hidden;
		display: block;
		width: 5.64rem;
		/* height: 0.82rem; */
		margin: 0 auto;
		margin-top: 0.9rem;
		border-left: 0.13rem solid #C72E2E;
	}
	.maxForm{
		overflow: hidden;
		display: block;
	}
	.maxForm .p2{
		display: block;
		width: 5.64rem;
		font-size: 0.3rem;
		color: #000000;
	    font-weight: 400;
		margin: 0 auto;
		margin-top: 0.24rem;
		margin-bottom: 0.22rem;
	}
	.maxForm .inputs{
		display: block;
		width: 5.44rem;
		height: 0.68rem;
		margin: 0 auto;
		font-size: 0.3rem;
		border: 0.02rem solid #CCCCCC;
		border-radius: 0.1rem;
		padding-left: 0.2rem;
	}
	.maxBtn{
		display: block;
		width: 5.64rem;
		height: 1.08rem;
		margin: 0 auto;
		background: url(../../../assets/img/trainingRegistration/sub.png)no-repeat;
		background-size:cover ;
		margin-top: 0.3rem;
		margin-bottom: 0.2rem;
		cursor: pointer;
	}
	.maxBtns{
		display: block;
		overflow: hidden;
	    width: 3.46rem;
		height: 0.9rem;
		line-height: 0.9rem;
		text-align: center;
		color: #c72e2e;
		border-radius: 0.45rem;
		font-size: 0.4rem;
		border: 0.02rem solid #c72e2e;
		margin: 0 auto;
		margin-top: 0.3rem;
		cursor: pointer;
	}
</style>
